module.exports = __webpack_public_path__ + "img/symbol_5.28471c12.png";